// extracted by mini-css-extract-plugin
module.exports = {"modal":"HistoryModal_modal__1Altg"};